import React, { Component } from 'react';
import { WorkoutInfo } from '../containers/Workouts';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

const stylesWorkout = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitleWorkout = withStyles(stylesWorkout)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContentWorkout = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default class WorkoutNotes extends Component {

  state = {
    open: true
  };

  render() {
    const { workout, planNotes } = this.props;
    const {open} = this.state;
    if (!workout) return null;
    return (
      <div>
        <Dialog  onClose={() => this.setState({ open: false })} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitleWorkout id="customized-dialog-title" onClose={() => this.setState({ open: false })}>
          View Notes
        </DialogTitleWorkout>
          <DialogContentWorkout dividers>
            <Typography gutterBottom component="span">
              <div className="modalBody modal-content" style={{ width: 320 }}>
                <WorkoutInfo workoutId={workout._id} planNotes={planNotes} isViewNotes={true} />
              </div>
            </Typography>
          </DialogContentWorkout>
      </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WorkoutNotes.js